import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { of, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-day-details',
  templateUrl: './day-details.component.html',
  styleUrls: ['./day-details.component.scss']
})
export class DayDetailsComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute, private router: Router) { }

  data$: Observable<any>;

  rowClickedFunc(group: string, key: string) {
    this.router.navigate([group, key], {relativeTo: this.activatedRoute});
  }

  ngOnInit() {
    this.data$ = this.activatedRoute.params.pipe(
      map(p => p.day),
      switchMap(day => of({
        day: day,
        groups: [
          {
            name: 'Drivers',
            headers: ['Driver', 'Standbys', 'Pay', 'Hours'],
            keyFunc: (d) => d.number,
            columnsFunc: (d) => {
              return [
                `${d.number} - ${d.name}`,
                `${d.numStandbys} / ${d.numScheduled}`,
                `$${d.pay}`,
                `${d.totalTime}`
              ];
            },
            markets: [
              {
                name: 'Los Angeles',
                details: [
                  {
                    number: '11021', name: 'SANDERS, MILTON', numStandbys: '2', numScheduled: '0',
                    pay: 73.02, totalTime: '05:30'
                  },
                  {
                    number: '10904', name: 'TAHERI, MOSSY G.', numStandbys: '1', numScheduled: '1',
                    pay: 42.48, totalTime: '03:12'
                  },
                  {
                    number: '10693', name: 'BROCKER, TIMOTHY', numStandbys: '1', numScheduled: '0',
                    pay: 27.56, totalTime: '02:04'
                  }
                ]
              },
              {
                name: 'NY / NJ',
                details: [
                  {
                    number: '2880', name: 'KALLER, DAVID', numStandbys: '1', numScheduled: '0',
                    pay: 32.02, totalTime: '03:20'
                  },
                  {
                    number: '3637', name: 'TEJADA, ARAMIS', numStandbys: '2', numScheduled: '0',
                    pay: 28.06, totalTime: '02:14'
                  }
                ]
              }
            ]             
          },
          {
            name: 'Locations',
            headers: ['Location', 'Drivers', 'Pay', 'Hours'],
            keyFunc: (d) => d.locationName,
            columnsFunc: (d) => {
              return [
                `${d.locationName}`,
                `${d.numDrivers} / ${d.numScheduled}`,
                `$${d.pay}`,
                `${d.totalTime}`
              ];              
            },
            markets: [
              {
                name: 'Los Angeles',
                details: [
                  { locationName: 'EMPIRECLS BASE', numDrivers: 6, numScheduled: 1, pay: 116.63, totalTime: '08:48' },
                  { locationName: 'BHH', numDrivers: 5, numScheduled: 0, pay: 70.16, totalTime: '05:17' },
                  { locationName: 'Beverly Wilshire', numDrivers: 3, numScheduled: 0, pay: 53.30, totalTime: '04:01' }
                ]
              },
              {
                name: 'NY / NJ',
                details: [
                  { locationName: 'Gap Time 3 hours', numDrivers: 9, numScheduled: 0, pay: 176.96, totalTime: '19:25' },
                  { locationName: 'FSH', numDrivers: 10, numScheduled: 1, pay: 161.78, totalTime: '17:35' },
                  { locationName: 'Specialty Vehicle', numDrivers: 11, numScheduled: 1, pay: 96.04, totalTime: '10:49' }
                ]
              }
            ]
          },
          {
            name: 'Dispatchers',
            headers: ['Dispatcher', 'Locations', 'Drivers', 'Pay', 'Hours'],
            keyFunc: (d) => d.dispatcher,
            columnsFunc: (d) => {
              return [
                `${d.dispatcher}`,
                `${d.numLocations}`,
                `${d.numDrivers} / ${d.numScheduled}`,
                `$${d.pay}`,
                `${d.totalTime}`
              ];   
            },
            markets: [
              {
                name: 'Los Angeles',
                details: [
                  { dispatcher: 'rnunez', numLocations: 3, numDrivers: 13, numScheduled: 0, pay: 232.75, totalTime: '17:34' },
                  { dispatcher: 'nj', numLocations: 4, numDrivers: 14,  numScheduled: 0, pay: 182.79, totalTime: '13:47' }
                ]

              },
              {
                name: 'NY / NJ',
                details: [
                  { dispatcher: 'lrw', numLocations: 3, numDrivers: 12, numScheduled: 0, pay: 181.47, totalTime: '19:54' },
                  { dispatcher: 'lpg', numLocations: 3, numDrivers: 10,  numScheduled: 0, pay: 131.64, totalTime: '13:08' }
                ]
              }
            ]
          }
        ]
      })));
  }

}
